<template>
    <div :class="`kat-flag kat-flag-${country.toLowerCase()}`" />
</template>

<script>
/**
 * Based on kat-flag: https://katal.amazon.dev/components/flag/. To add a new
 * icon: download the SVG file from https://code.amazon.com/packages/KatalComponents/trees/mainline/--/public/flags,
 * put it in /src/images/flags, and update the $countries SCSS variable below.
 */
export default {
    name: 'KatFlag',
    props: {
        country: {
            type: String,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.kat-flag {
    display: inline-block;
    height: 15px;
    vertical-align: middle;
    width: 20px;
}

$countries: 'ae', 'au', 'be', 'br', 'ca', 'cl', 'cn', 'co', 'de', 'eg', 'es', 'fr', 'gb', 'in', 'it', 'jp', 'mx', 'ng',
    'nl', 'pl', 'sa', 'se', 'sg', 'tr', 'us', 'za';

@each $country in $countries {
    .kat-flag-#{$country} {
        background-image: url('/src/images/flags/#{$country}.svg');
    }
}
</style>
